import { render } from "./CashRegisterDetailView.vue?vue&type=template&id=4c0ed583"
import script from "./CashRegisterDetailView.vue?vue&type=script&lang=js"
export * from "./CashRegisterDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__